var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 23 20",
    width: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 10.4277c0 2.2637 1.90186 4.0821 4.79639 4.0821h5.59421v3.7851c0 .3897.3433.7144.7422.7144s.7329-.3247.7329-.7144v-3.7851h6.0489c2.5419 0 4.2675-1.5772 4.2675-3.6924 0-1.75344-1.0669-3.33058-2.7925-4.04494.0186-3.93359-2.811-6.77246-6.4292-6.77246-2.3657 0-4.0727 1.26172-5.1396 2.81104-2.03174-.53809-4.53662 1.0205-4.59228 3.48828-1.99463.33398-3.22852 2.0874-3.22852 4.12838zm10.3999 3.7017v-4.49024l.0557-1.30811-.4453.4917-1.42876 1.52145c-.12988.1392-.3247.2134-.51025.2134-.38037 0-.65869-.269-.65869-.64012 0-.19482.07422-.34326.21338-.48242l2.95942-2.85742c.1856-.18555.3526-.24121.5474-.24121.1856 0 .3526.05566.5381.24121l2.9595 2.85742c.1391.13916.2134.2876.2134.48242 0 .37112-.2876.64012-.668.64012-.1763 0-.3618-.0742-.4917-.2134l-1.4287-1.52145-.4453-.4917.0556 1.30811v4.49024c0 .3989-.334.7236-.7329.7236-.4082 0-.7329-.3247-.7329-.7236z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.feefb8a6.svg";
export { ForwardRef as ReactComponent };